<template>
  <v-navigation-drawer v-model="adminSidebarOpen"
    class = "adminSidebar"
    width = "500"
    fixed
    temporary
    stateless
    touchless
    right>
    <v-toolbar flat>
    <v-list class="pt-2">
            
        <v-list-tile>
            <v-list-tile-content align-center>
                <v-list-tile-title style="padding-top: 2px;" class="title">
                    <v-layout>
                        <v-flex>
                            Admin Menu
                        </v-flex>
                    </v-layout>
                </v-list-tile-title>

            </v-list-tile-content>
            <v-list-tile-action align-center>
                <v-btn icon @click.stop="updateAdminSidebar(false)">
                    <v-icon>chevron_right</v-icon>
                </v-btn>
            </v-list-tile-action>
        </v-list-tile>

    </v-list>
    </v-toolbar>

    <v-divider></v-divider>  
    <v-layout class="pt-2 pl-2" column fill-height >  
    <v-flex>
        <v-list class="pt-4 pl-3">

            <v-list-tile :to="`/roomviewer/`" exact @click="gotoRoomViewer()">
                <v-list-tile-action>
                    <v-icon>line_style</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">Room Viewer</v-list-tile-title>
                </v-list-tile-content>           
            </v-list-tile>

            <v-list-tile exact @click="gotoBldgViewer()">
                <v-list-tile-action>
                    <v-icon>apartment</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">Building Viewer</v-list-tile-title>
                </v-list-tile-content>           
            </v-list-tile>            

            <v-list-tile to="" exact @click="roomAssociation">
                <v-list-tile-action>
                    <v-icon>swap_horiz</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">Room Association</v-list-tile-title>
                </v-list-tile-content>           
            </v-list-tile>

            <v-list-tile to="/stats/" exact @click="updateAdminSidebar(false)">
                <v-list-tile-action>
                    <v-icon>table_chart</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">Stats</v-list-tile-title>
                </v-list-tile-content>           
            </v-list-tile>
     
            

            <v-list-tile to="" @click="reviewPhotos">
                <v-list-tile-action>
                    <v-badge overlap color="red" :value="showIndicatorPhotoReview">
                        <template v-slot:badge>
                            <span>!</span>
                        </template>
                        <v-icon>photo_library</v-icon>
                    </v-badge>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">Review Photos</v-list-tile-title>
                </v-list-tile-content>           
            </v-list-tile>

            

            <v-list-tile to="" @click="setShowPermissionsEditor(true); adminSidebarOpen=false">
                <v-list-tile-action>
                    <v-icon>lock</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">Set Permissions</v-list-tile-title>
                </v-list-tile-content>           
            </v-list-tile>

            <v-list-group prepend-icon="manage_accounts" no-action>
                <v-list-tile slot="activator">
                    <v-list-tile-title  >Impersonate</v-list-tile-title>
                </v-list-tile>
                <EmployeeAutocomplete :key="reset" class="ml-1 mr-1" :singleline="true" v-on:return-employee="setImpersonation"/>
            </v-list-group>

        </v-list>
    </v-flex>

    <v-divider></v-divider>
    <v-subheader class="pt-3 mb-2 bigSub">Options</v-subheader>

    <v-flex>
        <v-list>
        <v-list-tile class="switches">
            <v-switch label="Use Dev Database" v-model="useDevDatabase"></v-switch>
        </v-list-tile>
        <v-list-tile to="/updateOccupancy/" @click="updateOccupancy">
                <v-list-tile-action>
<!--                     <v-badge overlap color="red" :value="showIndicatorPhotoReview">
                        <template v-slot:badge>
                            <span>!</span>
                        </template>
                        <v-icon>account_box</v-icon>
                    </v-badge> -->
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title :class="darkTheme ? 'adminlistitemdark' : 'adminlistitem'">Update Occupancy (beta)</v-list-tile-title>
                </v-list-tile-content>           
            </v-list-tile>
        </v-list>
        </v-flex>
    </v-layout>

    
    
  </v-navigation-drawer>
</template>

<script>
    import { mapActions, mapMutations, mapState } from 'vuex'
    import EmployeeAutocomplete from '@/components/forms/EmployeeAutocomplete'

    let AdminSidebar = {

        data() {
          return {
            reset: 1,
            dialogOpen: false,
          }
        },

        components: { EmployeeAutocomplete },

        computed: {
            ...mapState({
                stateAdminSidebarOpen:      state => state.ui.adminSidebarOpen,
                showTestDialog:             state => state.ui.showTestDialog,
                showIndicatorPhotoReview:   state => state.ui.showIndicatorPhotoReview,
                building:                   state => state.space.selectedBuilding,
                darkTheme:                  state => state.ui.darkTheme,
                impersonate:                state => state.user.impersonate,
            }),

            adminSidebarOpen: {
                get () {
                  return this.stateAdminSidebarOpen
                },
                set (value) {
                    this.updateAdminSidebar(value)
                }
            },

            useDevDatabase: {
                get () {
                  return this.$store.state.ui.useDevDatabase
                },
                set (value) {
                    this.setUseDevDatabase(!this.$store.state.ui.useDevDatabase)
                    this.initializeData('refresh')
                }
            },

        },

        methods: {
            ...mapActions(['selectBuilding', 'initializeData']),
            ...mapMutations([   'updateAdminSidebar', 'updateContentSidebar',
                                'setUseDevDatabase',
                                'setShowTestDialog',
                                'setShowPhotoReview',
                                'setShowUpdateOccupancy',
                                'updateRoomAssociationSidebar',
                                'setShowPermissionsEditor',
                                'setImpersonate',
                            ]),       
            
            setImpersonation(payload) {
                this.setImpersonate(payload)
                this.reset=this.reset+1
                this.closeDrawers()
            },

            reviewPhotos: function () {
                this.setShowPhotoReview(true)
                this.closeDrawers()
            },

            updateOccupancy: function () {
                this.setShowUpdateOccupancy(true)
                this.closeDrawers()
            },

            roomAssociation: function () {
                this.updateRoomAssociationSidebar(true)
                this.closeDrawers()
            }, 

            closeDrawers: function () {
                this.updateAdminSidebar(false)
                this.updateContentSidebar(false)
            },
            gotoBldgViewer() {
                console.log("Launch Building viewer")
                if(!this.building) {
                    this.$router.push({ name: 'bldgviewer'})
                    this.closeDrawers();
                } 
                else
                {
                    this.$router.push({ name: 'bldgviewerToBuilding', params: { dvbldg: this.building.bldgAlpha }})
                    this.closeDrawers();
                }
            },
            gotoRoomViewer() {
                console.log("Launch Roomviewer")
                if(!this.building) {
                    console.log("No Building")
                    this.$router.push({ name: 'roomviewer'})   
                    this.closeDrawers();
                }
                else {
                    this.$router.push({ name: 'RoomViewerToBldg', params: { rvbldg: this.building.bldgAlpha }})
                    this.closeDrawers();
                }
            },
        }
    }

    export default AdminSidebar
</script>

<style>

.adminSidebar {
    height: 100%;    
    z-index: 30 !important;
    overflow: hidden !important; 
}

  .adminlistitem {
    font-size: 17px;
    font-weight: 400;
    color: #666666 ;
  }

  .adminlistitemDark {
    font-size: 17px;
    font-weight: 400;
    color: #DDDDDD ;
  }

 
/* This exists in MainSidebar.vue
  .switches .v-label {
    left: 10px !important;
  }
*/

</style>



// WEBPACK FOOTER //
// src/components/AdminSidebar.vue